<template>
  <div class="project-banner" :class="mainCategory">
    <div class="banner-left">
      <h1 class="project-banner__title">{{ decodedTitle }}</h1>
        <p class="date" v-if="dateFormat">Date : {{ dateFormat }}</p>
        <SingleBannerCategories :categories="projectCategories" v-if="projectCategories.length > 0"/>
      <SingleBannerClient :client="client" />
      <p v-if="acf.collaborateurices">Collaborateur·ices : {{ acf.collaborateurices }}</p>
        <p v-if=" acf.lien"> En savoir plus : 
          <a :href="acf.lien"  target="_blank" rel="noopener noreferrer"> Site </a>
        </p>
    </div>
    <div class="banner-right">
        <div v-if="acf.contenu" v-html="acf.contenu"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
/*  IMPORTS  */
import type { Banner, Project } from '~/types/projects'

/*  PROPS  */
const props = defineProps<{
  acf: Banner
  title:string
  project:Project
}>()

function decodeHtmlEntities(str:string) {
  if (!str) return '';
  return str
    .replace(/&#8211;/g, '–')
    .replace(/&#038;/g, '&')
    .replace(/&amp;/g, '&'); // au cas où
}

const decodedTitle = decodeHtmlEntities(props.title);

const storeCategories = useStoreCategories();



await useAsyncData("categories",async () => {
    return await storeCategories.fetchCategories()
})

const { projectCategories, projectCategoriesSlug } = useCategories(toRef(props, 'project'))

const client = props.acf.client as any

/*  COMPUTED  */

const dateFormat = computed(() => {
  return props.acf.dates_du_projet?.split('/')?.pop() ?? ''
})

const mainCategory = computed(() => {
  const arrCategories = projectCategoriesSlug.value.split(" ")
  if(props.acf.categorie_principale)  {
    return props.acf.categorie_principale.slug
  ? arrCategories.filter(cat => cat === props.acf.categorie_principale.slug)
  : projectCategoriesSlug.value
  }else{
    return arrCategories[0]
  }
})
</script>

<style lang="scss">
.project-banner{
  display: flex;
  justify-content: space-between;
  @media screen and (max-width:600px) {
    flex-direction: column;
  }
  
  &.habillage-de-documentaire{
    .banner-left{
      background-image: url("~/assets/svgs/picto-habillage--light.svg");
    }
  }
  &.illustration{
    .banner-left{
      background-image: url("~/assets/svgs/picto-illustration--light.svg");
    }
  }
  &.graphisme{
    .banner-left{
      background-image: url("~/assets/svgs/picto-culture-expo--light.svg");
    }
  }
  &.motion{
    .banner-left{
      background-image: url("~/assets/svgs/picto-motion--light.svg");
    }
  }
  .banner-left,.banner-right{
    padding: 20px 0;
  }
  .banner-left{
    padding-right: 20px;
    width: 45%;
    background-repeat: no-repeat;
  background-position: center top;
  background-size: 90%;
  @media screen and (max-width:1035px) {
        background-position: center bottom -140px;
  }
  @media screen and (max-width:1035px) {
        background-position: center bottom -175px;
  }
  @media screen and (max-width:600px) {
   width: 100%;
   padding: 20px 0 ;
  }
    p{
      color:$text;
      margin: 0 0 10px 0;
      text-align: left;
      @media screen and (max-width:1035px) {
        font-size: 13px;
      }
    }
    a{
      color: $text;
    }
  }
  .banner-right{
    width: 55%;
    padding-bottom: 40px;
    @media screen and (max-width:1280px) {
      padding-left: 20px; 
    }
    @media screen and (max-width:600px) {
   width: 100%;
  }
    
    p{
      color: $text;
      font-size: 18px;
      font-weight: 600;
      text-align: left;
      max-width: 100%;
      @media screen and (max-width:1035px) {
        font-size: 15px;
      }
    }
  }
  &__title{
    color: $violet;
    font-weight: 800;
    font-style: italic;
    font-family: 'Open Sans', sans-serif;
    font-size: 35px;
    line-height: 40px;
    margin:0 0 20px 0;
    @media screen and (max-width:600px){
      font-size: 26px;
      line-height: 30px;
    }
}
}

</style>